export const PRICE_DATA = [
  {
    id: 1,
    plan: 'free',
    features: ['feature1', 'feature2', 'feature3'],
  },
  {
    id: 2,
    plan: 'monthly',
    popular: true,
    features: ['feature1', 'feature2', 'feature3', 'feature4', 'feature5'],
  },
  {
    id: 3,
    plan: 'yearly',
    features: ['feature1', 'feature2', 'feature3', 'feature4', 'feature5', 'feature6', 'feature7', 'feature8'],
  },
];
